module.exports = __webpack_public_path__ + "img/yelloop-point.717e4ecf.svg";